<template>
    <div class="caseApply">
        <div class="caseApplyHead">
            <!-- <div class="caseApplyTitle">病案复印助手</div> -->
            <van-steps :active="active" active-color="#fff">
                <van-step>复印申请</van-step>
                <van-step>身份认证</van-step>
                <van-step>复印信息</van-step>
                <van-step>支付结算</van-step>
            </van-steps>

        </div>
        <div class="caseApplyFourthTitle">
            <div class="caseApplyFourthLogo"></div>
            <div class="caseApplyFourthTxt" v-if="ruleForm1.serviceList.serviceId=='2'">
                <span>复印人:{{ruleForm1.Addressee}}</span>
                <span class="phoneNum">{{ruleForm1.phoneNum}}</span>
                <p>{{ruleForm1.stateName+ruleForm1.cityName+ruleForm1.districtName+ruleForm1.addressDescName}}</p>
            </div>
            <div class="caseApplyFourthTxt" v-if="ruleForm1.serviceList.serviceId!='2'">
                <span>复印人:{{casePersonMessage.patientName}}</span>
                <span class="phoneNum">{{casePersonMessage.phoneNum}}</span>
            </div>
        </div>
        <ul>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">申请信息:</span>
                    <!-- <van-icon name="arrow" />
                    <span class="chooseHospital" @click="selectMore" ref="openMore">{{openMore}}</span> -->
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">申请状态</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='0'">未支付</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='2'">已取消</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='4'">已支付</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='5'">通过审核</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='6'">审核未通过</span>
                    <span class="chooseHospital" v-if="ruleForm.statusId=='7'">支付中</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">医院信息</span>
                    <span class="chooseHospital1">{{hospitalObj.orgName}}</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">住院号</span>
                    <span class="chooseHospital1">{{ruleForm.hospitalCard}}</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">出院时间</span>
                    <span class="chooseHospital1">{{ruleForm.liEndDate}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="ruleForm1.serviceList.serviceId=='2'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">快递名称</span>
                    <span class="chooseHospital1">{{ruleForm.express_name}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="ruleForm1.serviceList.serviceId=='2'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">快递单号</span>
                    <span class="chooseHospital1" @click="selectExpressMsg">{{ruleForm.express_code}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="ruleForm1.serviceList.serviceId=='3'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">自提码</span>
                    <span class="chooseHospital1">{{ruleForm.express_code}}</span>
                </div>
            </li>
        </ul>
        <ul>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">复印信息:</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-for="item in ruleForm.casePathList" :key="item.value">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle" v-if="hospitalObj.copyFlag==0">{{item.serviceName}}</span>
                    <span class="IDCardTitle" v-if="hospitalObj.copyFlag==1">{{item.packageName}}</span>
                    <span class="chooseHospital1">{{item.value}}份</span>
                </div>
            </li>
            <!-- <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">医保报销</span>
                    <span class="chooseHospital1">1份</span>
                </div>
            </li> -->
        </ul>
        <ul>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">支付详情:</span>
                    <van-icon name="arrow" />
                    <span class="chooseHospital" @click="priceMore" ref="openMore1">{{openMore}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">复印费用（预收）</span>
                    <span class="chooseHospital">{{ruleForm.yffy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">邮寄费用</span>
                    <span class="chooseHospital">{{ruleForm.yjfy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">服务费用</span>
                    <span class="chooseHospital">{{ruleForm.fwfy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">支付金额:</span>
                    <span class="chooseHospital">{{ruleForm.totalMoney}}</span>
                </div>
            </li>
        </ul>
        <div class="caseApplyFooter">
            <input type="button" :value="btnName" :disabled="btnFlag" @click="payMoney" :class="btnFlag?'':'btnactive'">
        </div>
    </div>
</template>
<script>
  import {Toast} from 'vant'
  import ApiSetting from '@/assets/js/api'
  import tool from '@/assets/js/tool'
  export default {
    data () {
      return {
        active: 3,
        ruleForm: '',
        ruleForm1: '',
        hospitalObj: '',
        casePersonMessage: '',
        descFlag:false,
        priceMoreFlag:false,
        openMore:'查看更多',
        closeMore:'收起',
        btnName:'',
        btnFlag:false,
        orderEndTime:'',//应为支付超时结束时间
        orderStartTime:'',//应为接口获取到的保存订单时间
        contentTime:''
      }
    },
    created () {
        this.hospitalObj = JSON.parse(sessionStorage.getItem('obj'))
        this.ruleForm1 = JSON.parse(sessionStorage.getItem('casePathMessage'))
        this.ruleForm = JSON.parse(sessionStorage.getItem('casePathList'))
        this.casePersonMessage=JSON.parse(sessionStorage.getItem('casePersonMessage'))
        var timeStr=this.ruleForm.created_time.replace(/-/g,"/")
        this.orderStartTime = new Date(timeStr).getTime()
        this.orderEndTime=new Date(timeStr).getTime()+30*60*1000
        if(this.orderEndTime<=new Date().getTime()){
            //支付超时，不能支付
            this.btnName='支付超时'
            this.btnFlag=true
        }else{
            this.btnFlag=false
            this.countDown()
        }
    },
    methods: {
        selectExpressMsg(){
            this.$router.push({path: '/expressMsg'})
        },
        countDown () {
            var clock = window.setInterval(() => {
                var date = this.orderEndTime - new Date().getTime(); //计算剩余的毫秒数
                if(date <= 0){
                    //支付超时，不能支付
                    this.btnName='支付超时'
                    this.btnFlag=true
                    clearInterval(clock)
                }else{
                    var day = parseInt(date / 1000 / 60 / 60 / 24 , 10);
                    var hour = parseInt(date / 1000 / 60 / 60 % 24 , 10);
                    if(hour < 10){
                        hour = "0" +　hour
                    }
                    var min = parseInt(date / 1000 / 60 % 60, 10);//计算剩余的分钟
                    if(min< 10){
                        min= "0" +　min
                    }
                    var ss = parseInt(date / 1000 % 60, 10);//计算剩余的秒数
                    if(ss < 10){
                        ss = "0" +　ss
                    }
                    this.btnName=min+'分'+ss+'秒后超时，去支付'
                }
            }, 1000)
        },
        payMoney(){
            var param={
                orderId:this.ruleForm.orderId
            }
            this.postRequest(ApiSetting.pay,param).then((res) => {
                if(res.data.responseCode=='200'){
                    tool.gotoPay(
                            res.data.data.appId,
                            res.data.data.timeStamp,
                            res.data.data.nonceStr,
                            res.data.data.orderPackage,
                            res.data.data.signType,
                            res.data.data.paySign,
                            res.data.data.orderNo
                            )
                }else if (res.data.responseCode == '0') {
                    Toast.fail('获取支付签名失败，' + res.data.msg)
                } else {
                    Toast.fail('获取支付签名失败')
                }
            })

        },
        selectMore(){
            if(this.descFlag){
                this.descFlag=false
                this.$refs.openMore.innerText = this.openMore
            }else{
                this.descFlag=true
                this.$refs.openMore.innerText = this.closeMore
            }
        },
        priceMore(){
            if(this.priceMoreFlag){
                this.priceMoreFlag=false
                this.$refs.openMore1.innerText = this.openMore
            }else{
                this.priceMoreFlag=true
                this.$refs.openMore1.innerText = this.closeMore
            }
        },
      getPayValue () {
        var param = {
          orderId: this.ruleForm.orderId
        }
        this.postRequest(ApiSetting.pay,param).then((res) => {
            if(res.data.responseCode=='200'){
                tool.gotoPay(
                    res.data.data.appId,
                    res.data.data.timeStamp,
                    res.data.data.nonceStr,
                    res.data.data.orderPackage,
                    res.data.data.signType,
                    res.data.data.paySign,
                    res.data.data.orderNo
                    );
            }else if (res.data.responseCode == '0') {
                Toast.fail('获取支付签名失败，' + res.data.msg)
            } else {
                Toast.fail('获取支付签名失败')
            }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
    .caseApplyFourthTitle {
        background: #fff;
        color: #333333;
        border-bottom: 1px solid #e4e4e4;
        font-size: 0.28rem;
        width: 100%;
        height: auto;
        overflow: hidden;
        .caseApplyFourthLogo {
            width: 0.88rem;
            height: 0.88rem;
            margin-top: 0.16rem;
            display: inline-block;
            background: #b4ebf1;
            float: left;
            margin-right: 0.2rem;
            margin-left: 0.2rem;
            background: url('../assets/images/headerImg.png') no-repeat;
            background-size: 100%;
        }
        .caseApplyFourthTxt {
            span {
                display: inline-block;
                height: 0.6rem;
                line-height: 0.6rem;
            }
            p {
                height: 0.6rem;
                line-height: 0.6rem;
                margin: 0;
                width: 6rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
            }
            .phoneNum {
                float: right;
                margin-right: 0.2rem;
                color: #999999;
            }
        }

    }

    .caseApplyHead {
        border-bottom: 1px solid #e4e4e4;
    }

    .van-cell {
        padding: 0;
        padding-left: 0.2rem;
        height: 0.8rem;
        line-height: 0.8rem;
        /deep/
        .van-field__button {
            padding-right: 0.2rem !important;
        }
        .van-button--primary {
            color: #fff;
            background-color: #1C84F2;
            border: 1px solid #1C84F2;
            border-radius: 0.1rem;
        }
    }

    ul {
        background: #fff;
        clear: both;
        li {
            margin-left: 0.4rem;
        }
    }

    .caseApplyTypeNav {
        padding-left: 0;
        .chooseHospital1 {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #999999;
        }
        .van-icon{
            margin-right:0.2rem;
            font-size: 0.28rem;
            color: #1C84F2;
            float: right;
            top: 0rem !important;
            height: 1rem;
            line-height: 0.92rem;
        }
        .chooseHospital {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #1C84F2;
        }
        .IDCardTitle {
            display: inline-block;
            color: #333333;
        }
        .IDCardTitle1 {
            display: inline-block;
            color: #1C84F2;
        }
        .van-icon {
            position: relative;
            top: 0.04rem;
        }

    }


</style>

